export default class MinCostPerSquareFootVersionRequest {
    public description : string | null = null;
    
    public constructor() {
    }
}